import React from 'react';
import {Card, Col, Row, Tooltip, Divider, Button} from 'antd';
import {Link} from 'react-router-dom';
import {iconMap} from '../live/LiveDetail/Tabs/Teltale/iconMap';
import {options} from '../live/LiveDetail/Tabs/Teltale/options';
import statusMap from '../live/LiveDetail/Tabs/Teltale/statusMap';
import {FileExcelFilled} from '@ant-design/icons';
import canBusExportExcel from '../../../components/CanBusExportExcel';
import {useSelector} from 'react-redux';

const CanBusYellowCard = ({data}) => {

    const {user} = useSelector((state) => state.auth);

    const getVehiclesByStatus = (ttId, tts) => {
        return data
            .filter((item) =>
                item.conditionYellowDetails?.some(
                    (detail) => detail.tt_id === ttId && detail.tts === tts
                )
            )
            .map((item) => ({
                plateNumber: item.plateNumber,
                operationNumber: item.operationNumber,
                vehicleId: item.vehicleId,
                chassisNumber: item.chassisNumber,
            }));
    };

    const handleDownload = (vehicles, label) => {
        const vehiclesWithDetails = vehicles.map((vehicle) => {
            const matchingData = data.find((item) => item.vehicleId === vehicle.vehicleId);
            return {
                ...vehicle,
                conditionYellowDetails: matchingData?.conditionYellowDetails || [],
            };
        });

        canBusExportExcel(vehiclesWithDetails, 'Can Bus Uyarı', user?.name, label);
    };

    return (
        <Row gutter={[4, 4]}>
            {options.map((option) => {
                const status = statusMap[option.label];
                const vehicles = status ? getVehiclesByStatus(status.ttId, status.tts) : [];
                const isYellow = vehicles.length > 0;

                return (
                    <Col key={option.value} span={3} xs={8} sm={4} md={6} lg={6} xl={3}>
                        <Card
                            type="inner"
                            bordered
                            size="small"
                            style={{
                                border: isYellow ? '4px solid #ffcc00' : '1px solid #d9d9d9',
                            }}
                            bodyStyle={{padding: 0}}
                            extra={
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                    }}
                                >
                                    <h3 style={{fontSize: 11, marginRight: 5, marginTop: 5}}>
                                        Uyarılı araç sayısı: {vehicles.length}
                                    </h3>
                                    <Button
                                        disabled={!vehicles.length}
                                        type="link"
                                        icon={<FileExcelFilled/>}
                                        onClick={() => handleDownload(vehicles, option.label)}
                                        size="small"
                                    />
                                </div>
                            }
                        >
                            <div
                                className="live"
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    height: '100%',
                                }}
                            >
                                <Tooltip
                                    title={
                                        vehicles.length > 0 ? (
                                            <div
                                                style={{
                                                    maxHeight: '250px',
                                                    overflowY: 'auto',
                                                    textAlign: 'left',
                                                }}
                                            >
                                                {vehicles.map((vehicle, index) => (
                                                    <React.Fragment key={index}>
                                                        <Link
                                                            to={`/live/${vehicle.vehicleId}/2`}
                                                            style={{
                                                                display: 'block',
                                                                color: 'white',
                                                                marginBottom: '4px',
                                                            }}
                                                        >
                                                            {`${vehicle.plateNumber} - ${vehicle.operationNumber}`}
                                                        </Link>
                                                        {index < vehicles.length - 1 && (
                                                            <Divider style={{margin: '4px 0'}}/>
                                                        )}
                                                    </React.Fragment>
                                                ))}
                                            </div>
                                        ) : (
                                            <div style={{color: 'white'}}>Uyarı Yok</div>
                                        )
                                    }
                                    placement="rightBottom"
                                >
                                    <h4 style={{marginBottom: 'auto'}}>
                                        {iconMap[option.value]}
                                    </h4>
                                </Tooltip>
                                <h5
                                    style={{
                                        color: isYellow ? '#856404' : 'black',
                                        marginTop: 'auto',
                                        textAlign: 'center',
                                        wordBreak: 'break-word',
                                        maxWidth: '90%',
                                    }}
                                >
                                    {option.label}
                                </h5>
                            </div>
                        </Card>
                    </Col>
                );
            })}
        </Row>
    );
};

export default CanBusYellowCard;
